<template>
    <v-layout justify-center>
        <v-responsive width="100%">
            <v-row class="ma-n2">
                <v-col class="pa-2" cols="12" md="8" lg="9">
                    <v-row class="ma-n2">
                        <v-col class="pa-2" cols="12">
                            <statistics-common-filter v-model="searchDateValue" v-bind="{ loading }" @input="updatedCount = 0" />
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <statistics-recruitment-applications
                                v-bind="{
                                    searchDateValue,
                                    loading,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <v-row class="ma-n2" align="stretch">
                                <v-col class="pa-2" cols="12" md="6" lg="3">
                                    <statistics-recruitment-workexperience
                                        v-bind="{
                                            searchDateValue,
                                        }"
                                        v-on="{
                                            updated,
                                        }"
                                    />
                                </v-col>
                                <v-col class="pa-2" cols="12" md="6" lg="3">
                                    <statistics-recruitment-languages
                                        v-bind="{
                                            searchDateValue,
                                        }"
                                        v-on="{
                                            updated,
                                        }"
                                    />
                                </v-col>
                                <v-col class="pa-2" cols="12" md="6" lg="3">
                                    <statistics-recruitment-certification
                                        v-bind="{
                                            searchDateValue,
                                        }"
                                        v-on="{
                                            updated,
                                        }"
                                    />
                                </v-col>
                                <v-col class="pa-2" cols="12" md="6" lg="3">
                                    <statistics-recruitment-residence
                                        v-bind="{
                                            searchDateValue,
                                        }"
                                        v-on="{
                                            updated,
                                        }"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col class="pa-2" cols="12" md="4" lg="3">
                    <v-row class="ma-n2 flex-column">
                        <v-col class="pa-2" cols="12">
                            <statistics-recruitment-recruitments
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                        <v-col class="pa-2" cols="12">
                            <statistics-recruitment-consequences
                                v-bind="{
                                    searchDateValue,
                                }"
                                v-on="{
                                    updated,
                                }"
                            />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import dayjs from "@/plugins/vue-dayjs";

import StatisticsCommonFilter from "@/components/console/statistics/common/statistics-common-filter.vue";
import StatisticsRecruitmentApplications from "@/components/console/statistics/recruitment/statistics-recruitment-applications.vue";
import StatisticsRecruitmentCertification from "@/components/console/statistics/recruitment/statistics-recruitment-certification.vue";
import StatisticsRecruitmentConsequences from "@/components/console/statistics/recruitment/statistics-recruitment-consequences.vue";
import StatisticsRecruitmentLanguages from "@/components/console/statistics/recruitment/statistics-recruitment-languages.vue";
import StatisticsRecruitmentRecruitments from "@/components/console/statistics/recruitment/statistics-recruitment-recruitments.vue";
import StatisticsRecruitmentResidence from "@/components/console/statistics/recruitment/statistics-recruitment-residence.vue";
import StatisticsRecruitmentWorkexperience from "@/components/console/statistics/recruitment/statistics-recruitment-workexperience.vue";

export default {
    components: {
        StatisticsCommonFilter,
        StatisticsRecruitmentApplications,
        StatisticsRecruitmentCertification,
        StatisticsRecruitmentConsequences,
        StatisticsRecruitmentLanguages,
        StatisticsRecruitmentRecruitments,
        StatisticsRecruitmentResidence,
        StatisticsRecruitmentWorkexperience,
    },
    data: () => ({
        searchDateValue: [
            //
            dayjs().subtract(1, "month").add(1, "day").startOf("day").toISOString(),
            dayjs().endOf("day").toISOString(),
        ],

        updatedCount: 0,
    }),
    computed: {
        loading() {
            return this.updatedCount < 7;
        },
    },
    methods: {
        updated() {
            this.updatedCount += 1;
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    th,
    td {
        border-color: var(--v-content-base) !important;
    }
}
</style>